export default {
    state: {
        userProfilePhoto: null,
        userStoryPhoto: null
    },
    mutations:{
        setUserProfilePhoto(state, payload) {
            state.userProfilePhoto = payload;
        },
        setUserStoryPhoto(state, payload) {
            state.userStoryPhoto = payload;
        }
    },
    actions:{
        setUserProfilePhoto({commit}, payload) {
            commit('setUserProfilePhoto', payload)
        },
        setUserStoryPhoto({commit}, payload) {
            commit('setUserStoryPhoto', payload)
        }
    },
    getters:{
        userProfilePhoto (state) {
            return state.userProfilePhoto;
        },
        userStoryPhoto (state) {
            return state.userStoryPhoto;
        }
    }
}
